import { z } from 'zod';

const failureSchema = z.object({
  response: z.object({ status: z.number().optional(), data: z.unknown() }),
});
const bodySchema = z.object({ code: z.string().optional(), detail: z.string().optional() });

const responseOf = (error: unknown) => failureSchema.safeParse(error).data?.response;
const bodyOf = (error: unknown) => bodySchema.safeParse(responseOf(error)?.data).data;

export const serverErrorCode = (error: unknown): string | undefined => bodyOf(error)?.code;

export const serverErrorStatus = (error: unknown): number | undefined => responseOf(error)?.status;

export const serverErrorDetail = (error: unknown): string | undefined => bodyOf(error)?.detail;

/** The server's code when it is one of `codes`, so a code the caller has no copy for reads as null. */
export const knownServerErrorCode =
  <Code extends string>(codes: readonly Code[]) =>
  (error: unknown): Code | null => {
    const code = serverErrorCode(error);
    return codes.find((known) => known === code) ?? null;
  };
